import { UseQueryResult, UseMutationResult } from "@tanstack/react-query/src/types";
import { AxiosError, AxiosResponse } from "axios/index";
import { useQuery, useMutation } from "@tanstack/react-query";
import { getMariaData } from "src/api/admin/maria";

type IUseMariaDataRequest = (
  params?: AdminAPI.Maria.MariaResearch.Request,
) => UseQueryResult<AxiosResponse<AdminAPI.Maria.MariaResearch.Response>, AxiosError<AdminAPI.Maria.MariaResearch.ErrorResponse>>;

export const useMariaDataRequest: IUseMariaDataRequest = (params) =>
  useQuery(["useMariaDataRequest", params], async () => await getMariaData());
